<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-item-order-table ref="table" :items.sync="values" :toolbar="false" :title="title"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ItemOrder} from "@/modules/redactor/models/item-order/ItemOrder";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RItemOrderTable from "@/modules/redactor/views/item-order/r-item-order-table.vue";

export default {
  name: "r-item-order-panel",
  components: {RItemOrderTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Orders"),
    items: VueTypes.arrayOf(ItemOrder)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>